import WarningIcon from '@mui/icons-material/Warning';
import { Tooltip } from '@mui/material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { currencyCell } from 'components/cells';
import DataGridCell from 'components/cells/DataGridCell';
import { createColumns } from 'components/enhanced/data-grid/utils';
import { useTranslation } from 'react-i18next';
import { IRoleName } from './types';

export function RoleNameColumns(): GridColDef[] {
  const { t } = useTranslation();
  return createColumns<IRoleName>(
    [
      {
        field: 'code',
        headerName: t(`global.code`),
        minWidth: 250,
        editable: true
      },
      {
        field: 'fte',
        editable: true,
        type: 'number'
      },
      {
        field: 'monthly_hours',
        editable: true,
        type: 'number',
        valueFormatter: (params) =>
          Number(params.value ?? 0)
            .toFixed(2)
            .replace('.', ','),
        renderCell: (params) => <DataGridCell content={params.formattedValue} />
      },
      {
        field: 'monthly_cost',
        editable: true,
        type: 'number',
        renderCell: currencyCell
      },
      {
        field: 'used_fte',
        type: 'number',
        sortable: false,
        filterable: false,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <>
              {((+params.value).toFixed(2) as string).replace('.', ',')}
              {params.value > params.row.fte && (
                <Tooltip title={t(`entities.role_name.alerts.fte_exceeded`)}>
                  <WarningIcon color="error" />
                </Tooltip>
              )}
            </>
          );
        }
      }
    ],
    t,
    'entities.role_name'
  );
}
